/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptions
 */
export interface FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptions {
    /**
     * Публичный ключ для Cloudflare Turnstile
     * @type {string}
     * @memberof FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptions
     */
    SiteKey: string;
}

/**
 * Check if a given object implements the FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptions interface.
 */
export function instanceOfFxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptions(value: object): value is FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptions {
    if (!('SiteKey' in value) || value['SiteKey'] === undefined) return false;
    return true;
}

export function FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptionsFromJSON(json: any): FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptions {
    return FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptionsFromJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'SiteKey': json['SiteKey'],
    };
}

export function FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptionsToJSON(json: any): FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptions {
    return FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptionsToJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptionsToJSONTyped(value?: FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'SiteKey': value['SiteKey'],
    };
}

